import { StyledProductRow } from "./StyledProductList";
import { navigate } from 'gatsby';
import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";

const Product = ({ product }) => {

    const { frontmatter: detail } = product.node;

    const imageStyle = {backgroundColor: 'gray', color: 'lightgray', objectFit: 'cover', width: '100%', height: '250px'};
    return (
        <div onClick={() => navigate(product.node.fields.slug)}>
            {detail.gallery
                ? <GatsbyImage
                    imgStyle={imageStyle}
                    style={imageStyle}
                    objectFit={'cover'}
                    image={detail.gallery[0].childImageSharp.gatsbyImageData} alt='watch-image' />
                : <div style={imageStyle}>no photo</div>
            }
            <p>{detail.title}</p>
        </div>
    );
};
export default Product;
